import { css } from "@emotion/react";

export const RebateTableStyle = {
  wrapper: css``,

  loadingData: css`
    display: flex;
    justify-content: center;
    align-items: center;

    gap: 5px;

    font-size: 12px;
  `,
};
